<div class="flex flex-col gap-2 flex-wrap w-full">
    @if (label(); as label) {
        <app-label [required]="required()">{{ label }}</app-label>
    }
    <div class="flex w-full gap-6">
        <div class="flex flex-col w-full gap-2">
            <div
                class="p-4 min-w-[20rem] w-full gap-4 border border-gray-200 border-dashed rounded-lg flex flex-col items-center justify-center transition-all"
                [class]="
                    isDragOvered()
                        ? 'bg-[#F4FAFD] border-primary-200'
                        : 'bg-gray-50 border-gray-200'
                "
                [ngClass]="
                    value()
                        ? ''
                        : 'hover:border-primary-200 hover:bg-[#F4FAFD] cursor-pointer'
                "
                (click)="handleClick()"
                (dragover)="onDragOver($event)"
                (dragleave)="onDragLeave($event)"
                (drop)="onDragDrop($event)"
            >
                @if (value(); as item) {
                    <div class="flex gap-1 items-center text-center">
                        <app-icon
                            name="mdi:file-outline"
                            class="text-gray-500"
                        />
                        <p class="text-sm text-gray-800">
                            {{ item.name }}
                        </p>
                        @if (item.size; as size) {
                            <p class="text-gray-400 text-xs">
                                {{ size | fileSize }}
                            </p>
                        }
                    </div>
                } @else {
                    <div class="flex flex-col gap-1 text-center">
                        <p class="text-sm text-gray-400">
                            파일을 드래그하거나 클릭하여 업로드 해주세요.
                        </p>
                    </div>
                }
            </div>
        </div>
    </div>
</div>
<input #inputRef class="hidden" id="app-file-uploader" type="file" />
